import { mapState } from 'vuex';

export default {
  inject: ['$i18n'],

  computed: {
    planDetails() {
      const { header, onboardingItems } = this;
      const freq = this.currentUser.plan_pricing_data.is_annual_frequency ? 'annual' : 'monthly';
      const pricingData = this.currentUser.plan_pricing_data.premium[freq];

      return {
        plan: 'premium',
        name: 'Premium',
        image: 'graphics/plans-premium',
        pairingItems: [],
        price: pricingData.long,
        header,
        onboardingItems,
        showPricingCalc: pricingData.is_default,
      };
    },

    header() {
      return { onboarding: 'EVERYTHING IN STANDARD, PLUS:' };
    },

    onboardingItems() {
      const details = [
        'Create and implement custom Donut Journeys with unlimited Slack and email messages per Journey',
        'Unlimited targeted introductions and fully customizable messages',
        'Use Intros and Watercooler in Enterprise Grid multi-workspace channels',
        'Unlimited custom celebration dates',
      ];
      if (this.freePlanLimits.shoutouts_access) {
        details.push(`Unlimited access to ${this.i18nComputed.feature_name} for peer-to-peer recognition, including custom features like core values`);
      } else {
        details.push(`Recognize great work and celebrate wins with ${this.i18nComputed.feature_name}`);
      }
      if (this.currentUser.gatheround_available !== false) {
        details.push('Run engaging onboarding, training, and coaching sessions with Gatheround');
      }
      return details;
    },

    ...mapState([
      'currentUser',
      'currentPlan',
      'page',
      'freePlanLimits',
    ]),
  },
};
